export const ACTION_ADD_DIALOG = 'dialog/ADD_DIALOG';
export const ACTION_REMOVE_DIALOG = 'dialog/REMOVE_DIALOG';
export const ACTION_DIALOG_NOTHING = 'dialog/DIALOG_NOTHING';
